import { render, staticRenderFns } from "./CotStatiEditPage.vue?vue&type=template&id=05dc5b3c"
import script from "./CotStatiEditPage.vue?vue&type=script&lang=js"
export * from "./CotStatiEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports